import React from 'react';
import { useTranslation } from 'react-i18next';

function ErrorBoundaryInline({ onRetry, showRetry = true }) {
  const { t } = useTranslation();

  return (
    <div className="hub-error-inline" role="alert">
      <p className="hub-error-inline__message">
        {t('errors.recovery.inlineUnexpected')}
      </p>
      {showRetry ? (
        <button type="button" className="btn primary" onClick={onRetry}>
          {t('errors.recovery.actions.retry')}
        </button>
      ) : null}
    </div>
  );
}

export default ErrorBoundaryInline;
